<template>
  <div class="material-card-list mr-6 mb-6">
    <div class="image relative mb-2">
      <div class="absolute top-2 left-2 bg-white rounded w-6 h-6 flex justify-center items-center">
        <i
          v-if="!material.data.attributes.status"
          class="fa fa-lock text-red-500"
          :title="$t('main.blocked')"
        ></i>
        <i
          v-else
          class="fa fa-check text-green-500"
          :title="$t('main.published')"
        ></i>
      </div>
      <button
        :title="$t('main.button_delete')"
        @click="
          $store.dispatch(
            'elements/removeElementMaterial',
            material.data.material_id
          )
        "
        class="absolute top-2 right-2 bg-white rounded w-6 h-6 flex justify-center items-center"
      >
        <i class="fas fa-times fa-lg text-red-500"></i>
      </button>
      <div
        class="thumb block rounded border-2 border-white"
        :style="{ backgroundImage: `url(${material.data.attributes.image})` }"
      ></div>
    </div>
    <div class="article font-bold text-sm">
      {{ material.data.attributes.article }}
    </div>
    <div class="name text-xs">
      {{ material.data.attributes.name.substr(0, 15) }}...
    </div>
    <div class="coefficient text-sm">
      {{ $t('admin.materials.list_card_in_element.coef') }}:
      <span class="font-bold underline">{{
        material.data.attributes.cost_coefficient
      }}</span>
    </div>

    <div class="price-cub text-xs">
      <div v-html="$t('admin.materials.list_card_in_element.price_cub')"></div>
      <div>{{ $toCurrency(material.data.attributes.price) }}</div>
    </div>
    <div class="cost-value text-xs">
      <div v-html="$t('admin.materials.list_card_in_element.cost_cub')"></div>
      <div>{{ $toCurrency(material.data.attributes.cost) }}</div>
    </div>
    <div
      class="type text-xs"
      v-if="material.data.attributes.type"
    >
      {{ $knifeString(material.data.attributes.type.name, 15) }}
    </div>

  </div>
</template>

<script>
export default {
  name: "MaterialListCard",
  props: {
    material: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.material-card-list {
  display: flex;
  flex-direction: column;
  row-gap: 3px;
}
</style>
